import { Swiper, Pagination, Autoplay } from "swiper/bundle";
export default class Swiper1 {
    constructor() {
        console.log('%c👍🏼 Swiper 1', 'color: yellow');
        
        this.swiperImage = document.querySelectorAll(
            '.swiper--image'
        ) 
    }
    init() {
        this.swiperImage .forEach((elem, i) => {
            new Swiper(elem, {
                slidesPerView: 1.3,
                loop: true,
                spaceBetween: 10,
                speed: 2000,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true
                },
                breakpoints: {
                    568: {
                        spaceBetween: 15,
                        slidesPerView: 1.4,
                    },
                    992: {
                        spaceBetween: 20,
                        slidesPerView: 1.7,
                    }
                },
            });   
        })
    }
}